// COMPONENTS
import { Box, CircularProgress, Typography } from "@mui/material";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import React from "react";
import { formatFinance } from "../../../../utils/formatters";

export const SalesTrendChart = ({ data, loading }) => {
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 300,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Vendas (Últimos 30 Dias)
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Comparação diária de vendas entre delivery, retirada e salão
      </Typography>

      <Box sx={{ height: 300 }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="date"
              tickFormatter={(date) => {
                const d = new Date(date);
                return `${d.getDate()}/${d.getMonth() + 1}`;
              }}
            />
            <YAxis />
            <Tooltip formatter={(value) => [`${formatFinance(value)}`, ""]} />
            <Legend />
            <Line
              type="monotone"
              dataKey="indoor"
              stroke="#8884d8"
              activeDot={{ r: 8 }}
              name="Salão"
            />
            <Line
              type="monotone"
              dataKey="delivery"
              stroke="#82ca9d"
              name="Delivery"
            />
            <Line
              type="monotone"
              dataKey="takeout"
              stroke="#ffc658"
              name="Retirada"
            />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </>
  );
};
